import { refreshTokenRequest, refreshTokenResponse, signOutRequest } from "./auth.dto";
import { api } from "./contract";

export const refreshToken = api("POST", "/auth/refresh").withRequest(refreshTokenRequest).withResponse(refreshTokenResponse);

/** Revokes a refresh token (the body's, else the refresh cookie's) and clears the session cookies. Needs no access token. */
export const authSignOut = api("POST", "/auth/sign-out").withRequest(signOutRequest);

/**
 * A browser sends `cookie` in this header (see setRefreshTokenTransport) to have a sign-in answer with its refresh token in an
 * HttpOnly cookie scoped to the auth endpoints instead of the body. Devices send nothing and keep the token themselves.
 */
export const REFRESH_TOKEN_TRANSPORT_HEADER = "x-refresh-token-transport";
